module.exports = __webpack_public_path__ + "img/gunners_hall_small.1bb2172a.png";